import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo } from "@fortawesome/pro-regular-svg-icons/faVideo";
import styled from "@emotion/styled";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import cn from "classnames";
import { faPlay } from "@fortawesome/pro-regular-svg-icons/faPlay";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";

const ScrollbarStyles = styled.div`
    ::-webkit-scrollbar {
        height: 0;
        /* height: 20px; */
    }

    /* 4px scroll thumb. 10px margin from right margin */
    /* ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 15px 15px #000;
        border-top: solid 15px transparent;
    }

    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 15px 15px #333;
        border-top: solid 15px transparent;
    }

    ::-webkit-scrollbar-button {
        display: none;
    } */
`;

const Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faVideo} size="6x" />
    </div>
);

const VideoCarouselComponent = ({
    state: {
        videos = [],
        heading = "What they say",
        border,
        selectedCardIndex = null,
    },
    isEditMode,
    onChange,
    focused,
}) => {
    const [isAtStart, setIsAtStart] = useState(true);
    const [isAtEnd, setIsAtEnd] = useState(false);
    const [videoOverlayOpen, setVideoOverlayOpen] = useState(false);
    const [videoOverlayUrl, setVideoOverlayUrl] = useState("");
    const videosRef = useRef(null);

    const scroll = (direction) => {
        if (videosRef.current) {
            const { current } = videosRef;
            const gap = 28;
            let scrollAmount = 330 + gap;
            const video = document.querySelector(
                '[data-testid="videos__item-0"]'
            );

            if (video) {
                scrollAmount = video.clientWidth + gap;
            }

            if (direction === "left") {
                current.scrollLeft -= scrollAmount;
            } else {
                current.scrollLeft += scrollAmount;
            }
        }
    };

    const checkScrollPosition = () => {
        if (videosRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = videosRef.current;

            setIsAtStart(scrollLeft <= 0);
            setIsAtEnd(scrollLeft + clientWidth >= scrollWidth);
        }
    };

    useEffect(() => {
        checkScrollPosition();
        const scrollDiv = videosRef.current;

        if (scrollDiv) {
            scrollDiv.addEventListener("scroll", checkScrollPosition);
            window.addEventListener("resize", checkScrollPosition);
            return () => {
                scrollDiv.removeEventListener("scroll", checkScrollPosition);
                window.removeEventListener("resize", checkScrollPosition);
            };
        }
    }, []);

    return (
        <>
            <div className="flex flex-col items-center justify-between md:flex-row mb-[30px]">
                <h2
                    data-testid="product-relations__title"
                    className={
                        "text-center !text-[30px] !leading-[34px] text-brand-black !lg:text-[40px] !lg:leading-[46px] !mb-0"
                    }
                >
                    {heading}
                </h2>

                <div className="hidden gap-[10px] md:flex items-center">
                    <button
                        className={cn(
                            `h-[50px] w-[50px] rounded-full bg-brand-light-grey text-[20px] leading-[26px] text-brand-black hover:bg-brand-light-grey active:bg-brand-grey`,
                            {
                                "cursor-not-allowed opacity-25": isAtStart,
                            }
                        )}
                        onClick={() => scroll("left")}
                        disabled={isAtStart}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <button
                        className={cn(
                            `h-[50px] w-[50px] rounded-full bg-brand-light-grey text-[20px] leading-[26px] text-brand-black hover:bg-brand-light-grey active:bg-brand-grey`,
                            {
                                "cursor-not-allowed opacity-25": isAtEnd,
                            }
                        )}
                        onClick={() => scroll("right")}
                        disabled={isAtEnd}
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            </div>

            {videos?.length > 0 ? (
                <ScrollbarStyles
                    ref={videosRef}
                    className="flex scroll-smooth  flex-row content__videos overflow-auto gap-[30px]"
                >
                    {videos.map((video, idx) => {
                        return (
                            <div
                                key={`videos_${idx}`}
                                data-testid={`videos__item-${idx}`}
                                style={{
                                    boxShadow:
                                        selectedCardIndex === idx &&
                                        focused &&
                                        "inset 0 0 0 3px red",
                                }}
                                className={`flex flex-col w-[270px] min-w-[270px] max-w-[270px] lg:flex-[470px] lg:min-w-[470px] lg:max-w-[470px] gap-y-[15px] bg-brand-white`}
                                onClick={(e) => {
                                    if (isEditMode) {
                                        e.preventDefault();
                                        onChange({
                                            selectedCardIndex: idx,
                                        });
                                    }
                                }}
                            >
                                <div
                                    className="w-full relative aspect-[40/21] bg-brand-light-grey rounded-[10px]"
                                    style={{
                                        backgroundImage: video.thumbnail
                                            ? `url("${video.thumbnail}")`
                                            : "none",
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                    }}
                                >
                                    {video.url && (
                                        <button
                                            className="absolute text-brand-white lg:bottom-[30px] bottom-[15px] lg:left-[30px] left-[15px] lg:h-[50px] h-[30px] lg:w-[50px] w-[30px] bg-brand-primary rounded-full flex justify-center items-center"
                                            onClick={() => {
                                                setVideoOverlayOpen(true);
                                                setVideoOverlayUrl(video.url);
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faPlay}
                                                size="lg:w-[20px] w-[15px]"
                                            />
                                        </button>
                                    )}
                                </div>
                                <p
                                    className={`flex font-extrabold text-[24px] leading-[30px] mb-0`}
                                >
                                    {video.title}
                                </p>

                                <p
                                    className="text-brand-black text-[16px] leading-[22px] mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html: video.description,
                                    }}
                                />
                            </div>
                        );
                    })}
                </ScrollbarStyles>
            ) : (
                <Icon />
            )}

            <div className="mt-[15px] flex items-center justify-center gap-[10px] md:hidden">
                <button
                    className={cn(
                        `h-[50px] w-[50px] rounded-full bg-brand-light-grey text-[20px] leading-[26px] text-brand-black hover:bg-brand-light-grey active:bg-brand-grey`,
                        {
                            "cursor-not-allowed opacity-25": isAtStart,
                        }
                    )}
                    onClick={() => scroll("left")}
                    disabled={isAtStart}
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button
                    className={cn(
                        `h-[50px] w-[50px] rounded-full bg-brand-light-grey text-[20px] leading-[26px] text-brand-black hover:bg-brand-light-grey active:bg-brand-grey`,
                        {
                            "cursor-not-allowed opacity-25": isAtEnd,
                        }
                    )}
                    onClick={() => scroll("right")}
                    disabled={isAtEnd}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>

            {videoOverlayOpen && (
                <div
                    className="fixed inset-0 bg-black/50 z-50"
                    onClick={(e) => {
                        if (e.target.classList.contains("video-overlay")) {
                            setVideoOverlayOpen(false);
                        }
                    }}
                >
                    <div className="w-full h-full flex justify-center items-center video-overlay">
                        <button
                            className="absolute top-[20px] right-[20px] w-[50px] h-[50px] bg-brand-white rounded-full p-[10px]"
                            onClick={() => setVideoOverlayOpen(false)}
                        >
                            <FontAwesomeIcon icon={faTimes} size="w-[20px]" />
                        </button>
                        <div className="p-[15px] bg-brand-white rounded-[10px]">
                            <video
                                src={videoOverlayUrl}
                                controls
                                autoPlay
                                className="aspect-[16/9] max-w-[90vw]"
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoCarouselComponent;
